var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "v-card",
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.teams,
                search: _vm.search
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.formatedCreatedAt))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.member))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("v-select", {
                            attrs: { items: _vm.roles, outlined: "" },
                            on: {
                              change: function($event) {
                                return _vm.updateMemberRole(props.item)
                              }
                            },
                            model: {
                              value: props.item.role,
                              callback: function($$v) {
                                _vm.$set(props.item, "role", $$v)
                              },
                              expression: "props.item.role"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "grey lighten-1",
                                type: "button"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeMember(props.item)
                                }
                              }
                            },
                            [_vm._v("Remove")]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-50" },
      [
        _c("v-card", [
          _c(
            "form",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "padding-top": "0px" },
                      attrs: { fluid: "", "grid-list-sm": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  "search-input": _vm.search,
                                  "hide-selected": "",
                                  label: "Invite Members",
                                  multiple: "",
                                  "persistent-hint": "",
                                  "small-chips": "",
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    _vm.search = $event
                                  },
                                  "update:search-input": function($event) {
                                    _vm.search = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "no-data",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    '\n                          No results matching "'
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(_vm._s(_vm.search))
                                                  ]),
                                                  _vm._v('". Press '),
                                                  _c("kbd", [_vm._v("enter")]),
                                                  _vm._v(
                                                    " to create a new one\n                        "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.members,
                                  callback: function($$v) {
                                    _vm.members = $$v
                                  },
                                  expression: "members"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  filled: "",
                                  "auto-grow": "",
                                  label: "Message",
                                  rows: "4",
                                  "row-height": "30",
                                  shaped: ""
                                },
                                model: {
                                  value: _vm.message,
                                  callback: function($$v) {
                                    _vm.message = $$v
                                  },
                                  expression: "message"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: { items: _vm.roles, outlined: "" },
                                model: {
                                  value: _vm.role,
                                  callback: function($$v) {
                                    _vm.role = $$v
                                  },
                                  expression: "role"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green lighten-1", type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.sendInvite()
                        }
                      }
                    },
                    [_vm._v("Send Invite")]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { staticClass: "page-heading" }, [_vm._v("Owner Info")]),
        _vm._v(" "),
        _c("p", [_vm._v("Manage Users")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-227e25d9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227e25d9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ManageUsers.vue
// module id = null
// module chunks = 